import { render } from "./ResetAccount.vue?vue&type=template&id=1e925d1d&scoped=true"
import script from "./ResetAccount.vue?vue&type=script&lang=js"
export * from "./ResetAccount.vue?vue&type=script&lang=js"

import "./ResetAccount.vue?vue&type=style&index=0&id=1e925d1d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e925d1d"]])

export default __exports__